export default __webpack_public_path__ + "static/media/games-m.9f5b7930.svg";